






















import { defineComponent, computed, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';
import { i18n } from './../../../../i18n';

const name = 'ttam-behavior-creator-actions';
export default defineComponent({
  model: {
    prop: 'selectedActions',
    event: 'change',
  },
  props: {
    selectedActions: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { selectedActions } = toRefs(props);

    const _selectedActions = computed({
      get: () => selectedActions.value,
      set: val => {
        emit('change', val);
      },
    });
    const actions = () => [
      {
        label: i18n.t('adgroup_target_interest_add_following_behaviors_following'),
        value: 4,
      },
      {
        label: i18n.t('adgroup_target_interest_add_following_behaviors_homepage'),
        value: 5,
      },
    ];
    const onChange = vals => {
      emit('change', vals);
    };
    return {
      name,
      actions,
      _selectedActions,
      onChange,
    };
  },
});
